import { graphql } from '@/gql';
import type { CheckAndRecordGroceryPopupMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const checkAndRecordGroceryPopup = async ({
  phoneNumber,
  locations,
}: CheckAndRecordGroceryPopupMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckAndRecordGroceryPopup($phoneNumber: String!, $locations: [CoordinatesInput!]!) {
        checkAndRecordGroceryPopup(phoneNumber: $phoneNumber, locations: $locations)
      }
    `),
    variables: {
      phoneNumber,
      locations,
    },
  });

  return response.data?.checkAndRecordGroceryPopup ?? false;
};
